import { createContext } from 'react';

// 独立上下文避免 MainHeader 与导航容器互相引用。
const DesktopNavigationContext = createContext(null);
export default DesktopNavigationContext;
